import { render, staticRenderFns } from "./BookingCancelation.vue?vue&type=template&id=efa3587e&scoped=true&"
import script from "./BookingCancelation.vue?vue&type=script&lang=ts&"
export * from "./BookingCancelation.vue?vue&type=script&lang=ts&"
import style0 from "./BookingCancelation.vue?vue&type=style&index=0&id=efa3587e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa3587e",
  null
  
)

export default component.exports